import Campaign from '@/api/services/campaign'

const state = {
    isSamplingSeen: false,
    campaign: {
        "name": "Kampania domyślna",
        "token": "",
        "imageStep1": "/uploads/images/campaigns/default/3.jpg",
        "imageStep2": "/uploads/images/campaigns/default/4.jpg",
        "benefits1": `
            <p>
                <big><strong>Bądź w&nbsp;kontakcie z&nbsp;MAKRO</strong></big>
            </p>
            <ul class="typo-list">
                <li>Newsletterem powiadomimy Cię o najnowszej ofercie promocyjnej – już nie potrzebujesz papierowej gazetki</li>
                <li>Dzięki SMS dowiesz się o krótkich super promocjach</li>
                <li>Telefonicznie skontaktuje się z Tobą nasz przedstawiciel, aby dobrać ofertę dopasowaną do Twoich potrzeb</li>
            </ul>
        `,
        "benefits2": `
            <ol class="typo-list">
                <li>
                    Newsletterem powiadomimy Cię o najnowszej ofercie promocyjnej – już nie potrzebujesz papierowej gazetki
                </li>
                <li>
                    Dzięki SMS dowiesz się o krótkich super promocjach
                </li>
                <li>
                    Telefonicznie skontaktuje się z Tobą nasz przedstawiciel, aby dobrać ofertę dopasowaną do Twoich potrzeb
                </li>
            </ol>
        `,
        "consents": [],
        "articles": [],
        "type": "campaign"
    }
}

const getters = {
    campaign(state) {
        return state.campaign
    },

    consents(state) {
        return state.campaign.consents
    },

    isSampling(state) {
        return state.campaign.type === 'sampling'
    },

    isSamplingSeen(state) {
        return state.isSamplingSeen === true
    },

    samplingArticle: state => sampleId => {
        const out = state.campaign.articles.filter(item => item.id === sampleId)

        if (out.length > 0) {
            return out[0]
        }

        return {}
    }
}

const mutations = {
    setConsents(state, consents) {
        state.campaign.consents = consents
    },

    setCampaign(state, campaignData) {
        state.campaign = campaignData
    },

    setIsSamplingSeen(state, isSeen) {
        state.isSamplingSeen = isSeen
    },

    clearCampaign(state) {
        state.campaign.name = "Kampania domyślna"
        state.campaign.token = ""
        state.campaign.imageStep1 = "/uploads/images/campaigns/default/3.jpg"
        state.campaign.imageStep2 = "/uploads/images/campaigns/default/4.jpg"
        state.campaign.benefits1 = `
            <p>
                <big><strong>Bądź w&nbsp;kontakcie z&nbsp;MAKRO</strong></big>
            </p>
            <ul class="typo-list">
                <li>Świeży newsletter i&nbsp;aktualizacje wydarzeń Akademii Inspiracji</li>
                <li>Codzienne ekskluzywne oferty w&nbsp;najlepszej cenie</li>
                <li>Kontakt z&nbsp;przedstawicielem</li>
            </ul>
        `
        state.campaign.benefits2 = `
            <ol class="typo-list">
                <li>
                    Świeży newsletter i&nbsp;aktualizacje wydarzeń Akademii inspiracji
                </li>
                <li>
                    Codzienne ekskluzywne oferty w&nbsp;najlepszej cenie
                </li>
                <li>
                    Kontakt z&nbsp;przedstawicielem
                </li>
            </ol>`
        state.campaign.consents = []
        state.campaign.type = "campaign"
    }
}

const actions = {
    async resolveCampaign({ dispatch, commit }) {
        const defaultConsents = await dispatch('apiDefaultConsents/getDefaultConsents', {}, { root: true })

        try {
            const campaignData = await Campaign().getCampaign()

            let allConsents = campaignData.data.consents.slice()
            let allConsentsTypes = allConsents.map(item => item.type)

            for (let i = 0; i < defaultConsents.length; i++) {
                if (allConsentsTypes.indexOf(defaultConsents[i].type) === -1) {
                    allConsents.push(defaultConsents[i])
                }
            }

            commit('setCampaign', campaignData.data) // what for?
            dispatch('consentsResolver/setCampaignConsents', campaignData.data.consents, { root: true }) // which pending consents to show
            dispatch('consentsResolver/setResignationReasons', allConsents, { root: true }) // reasons for all consents (merged campaign with defaults)

            console.log('[Campaign] Loaded.')
        }
        catch(e) {
            commit('setConsents', defaultConsents)
            dispatch('consentsResolver/setCampaignConsents', defaultConsents, { root: true })
            dispatch('consentsResolver/setResignationReasons', defaultConsents, { root: true })

            console.log('[Campaign] Default loaded.')
        }
    },

    setIsSamplingSeen({ commit }, isSeen) {
        commit('setIsSamplingSeen', isSeen)
    },

    clearCampaign({ commit }) {
        return Campaign().clearCampaign().then(() => {
            commit('setIsSamplingSeen', false)
            commit('clearCampaign')
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
